import { render } from "./cart-thresholds.vue?vue&type=template&id=74194a6c"
import script from "./cart-thresholds.vue?vue&type=script&lang=js"
export * from "./cart-thresholds.vue?vue&type=script&lang=js"

import "./cart-thresholds.vue?vue&type=style&index=0&id=74194a6c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__